export { default as default } from './TabList';
